/* eslint-disable quotes */
// views.app.rewards.earn

export const EARN = {
  title: 'Earn Rewards',
  description:
    "Earn reward points for completing the below tasks. These tasks have been designed to help you strengthen your company's security posture as well as build the right cadence around managing security."
};
